<template>
    <div class="layout-container">
        <van-nav-bar :title="title" left-text="" @click-left="onClickLeft" left-arrow :fixed="true">
        </van-nav-bar>
        <img v-if="ad.adImgUrl" :src="ad.adImgUrl" class="wxcodeimg" :style="style">
    </div>
</template>

<script>
    import {getDeptId, getDeptName, setCookie} from "../../utils/auth";

    export default {
        data() {
            return {
                title:'公众号二维码',
                deptId: '',
                phone: '',
                deptName: '',
                ad:{},
            };
        },
        async created() {
            document.title = getDeptName()
            this.deptName = this.$route.params.deptName
            this.deptId = getDeptId()
            let val = window.innerWidth*0.85
            this.style='width:'+val+'px;'+'height:'+val+'px'
            this.getAds()
        },
        methods: {
            async getAds() {
                let data = {
                    adType: 7,
                    deptId: this.deptId
                }
                let res = await this.$get("/spm/getSpmAds", data)
                if (res.adList.length>0){
                    this.ad=res.adList[0]
                }
            },
            onClickLeft() {
                if (window.history.length > 1) {
                    this.$router.back();
                } else {
                    this.$router.push('/home/' + this.deptId)
                }
            },
        },
    };
</script>

<style lang="scss" scoped>

    .layout-container {
        margin: 0 auto;
        height: 100%;
        background-size: 100% 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .wxcodeimg{
      margin-top: -18%;
    }

</style>
